export const duration = {
    fast: 300,
    normal: 600,
} as const;

export const easing = {
    enter: "cubic-bezier(0.22, 1, 0.36, 1)",
} as const;

export const distance = {
    sm: 16,
    md: 28,
} as const;

export function prefersReducedMotion(): boolean {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return false;
    }
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
